module.exports = __webpack_public_path__ + "static/media/product-popup-image.7c847b1f.jpg";